import { cookie, isAuthenticated } from '@pmi/pmi-iqos-shared-react'

export default class Cart {
  constructor(api) {
    this.api = api
  }

  getCart = async (opts = {}) => {
    const res = await this.api.get('/cart', {
      ...opts,
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      mock: this.api.getMock('getCart')
    })
    return res
  }

  cartCheck = async () => {
    const res = await this.api.get('/cart/check', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      mock: this.api.getMock('cartCheck')
    })
    return res
  }

  getProducts = async (opts = {}) => {
    const res = await this.api.get('/catalogue/products', {
      ...opts,
      headers: {
        ...cookie.authorizationTokenHeader(opts ? opts.req : undefined)
      },
      mock: this.api.getMock(
        opts.params && !opts.params.stock
          ? 'getProducts'
          : 'getProductsWithStocks'
      )
    })
    return res
  }

  get3dModelProducts = async productId => {
    const res = await this.api.get(`/catalogue/products/${productId}/3dmodel`, {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      mock: this.api.getMock('get3dModelProducts')
    })
    return res
  }

  getDevicesBundles = async (opts = {}) => {
    const res = await this.api.get('/catalogue/bundles', {
      ...opts,
      headers: {
        ...cookie.authorizationTokenHeader(opts ? opts.req : undefined)
      },
      mock: this.api.getMock(
        opts.params && !opts.params.stock
          ? 'productBundleList'
          : 'productBundleListWithStocks'
      )
    })
    return res
  }

  getStockNotification = async product => {
    const res = await this.api.get('/catalogue/stocknotification', {
      params: { productid: parseInt(product.id, 10) },
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      mock: this.api.getMock('stocknotification')
    })
    return res
  }

  addStockNotification = async (
    userInfo,
    productId,
    selectedOption,
    recaptcha
  ) => {
    const data = userInfo
      ? {
          name: userInfo.name,
          email: userInfo.email,
          token: recaptcha.token,
          action: recaptcha.action,
          productId: parseInt(productId, 10),
          productOption: {
            optionId: selectedOption.optionId,
            variantId: selectedOption.variantId
          }
        }
      : {
          productId: parseInt(productId, 10),
          productOption: {
            optionId: selectedOption.optionId,
            variantId: selectedOption.variantId
          }
        }
    const res = await this.api.post('/catalogue/stocknotification', {
      data: data,
      headers: isAuthenticated()
        ? {
            ...cookie.authorizationTokenHeader()
          }
        : {},
      mock: this.api.getMock('stocknotification')
    })
    return res
  }

  addToCart = async (products, cartType, qureProduct) => {
    let res
    if (Array.isArray(products) && products.length) {
      const CartType = cartType
      const QureProduct = qureProduct
      res = await this.api.post('/cart/add', {
        headers: {
          ...cookie.authorizationTokenHeader()
        },
        withCredentials: true,
        useProxy: true,
        data: {
          CartProducts: products.map(p => {
            const product = {
              ...p.opts,
              ProductId: parseInt(p.id, 10),
              Amount: parseInt(p.qty, 10)
            }
            if (p.option) {
              product.ProductOptions = {
                OptionId: p.option.optionId,
                VariantId: p.option.variantId
              }
            }
            if (p.chainId) {
              product.ChainId = parseInt(p.chainId, 10)
            }
            if (p.options) {
              product.ProductOptions = {
                OptionId: p.options.optionId,
                VariantId: p.options.variantId
              }
            }
            return product
          }),
          ...(CartType && { CartType }),
          ...(QureProduct && { QureProduct })
        },
        mock: this.api.getMock('addToCart')
      })
    }
    return res
  }

  updateCart = async (
    ProductId,
    Amount,
    ProductOptions,
    newVariantId,
    chainId,
    cartType
  ) => {
    const option = ProductOptions && {
      OptionId: ProductOptions[0].optionId,
      VariantId: ProductOptions[0].variantId
    }
    const new_variant = newVariantId
    const ChainId = chainId ? parseInt(chainId, 10) : undefined
    const CartType = cartType
    const res = await this.api.post('/cart/update', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      data: {
        ProductId: parseInt(ProductId, 10),
        Amount: parseInt(Amount, 10),
        ProductOptions: option && option,
        ...{ ChainId },
        ...{ new_variant },
        ...(CartType && { CartType })
      },
      mock: this.api.getMock('updateCart')
    })
    return res
  }

  addCoupon = async couponCode => {
    const res = await this.api.post('/coupon/add', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      data: {
        CouponCode: couponCode
      },
      mock: this.api.getMock('addCoupon')
    })
    return res
  }

  removeCoupon = async couponCode => {
    const res = await this.api.post('/coupon/remove', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      data: {
        CouponCode: couponCode
      },
      mock: this.api.getMock('removeCoupon')
    })
    return res
  }

  removeFromCart = async (productId, cartType) => {
    const CartType = cartType
    const res = await this.api.post('/cart/delete', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      data: {
        ItemId: parseInt(productId, 10),
        ...(CartType && { CartType })
      },
      mock: this.api.getMock('deleteFromCart')
    })
    return res
  }

  placeOrder = async (
    PaymentId,
    fingerPrint,
    paymentMethod,
    additionalData,
    checksum,
    cartType,
    updateDefaultAddress
  ) => {
    const PaymentMethod = paymentMethod
    const AdditionalData = additionalData
    const CartType = cartType
    const res = await this.api.post('/PlaceOrder', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      withCredentials: true,
      useProxy: true,
      data: {
        PaymentId: parseInt(PaymentId, 10),
        FingerPrint: fingerPrint,
        Checksum: checksum,
        ...(PaymentMethod && { PaymentMethod }),
        ...(AdditionalData && { AdditionalData }),
        ...(CartType && { CartType }),
        ...(updateDefaultAddress && { updateDefaultAddress })
      },
      mock: this.api.getMock('placeOrder')
    })
    return res
  }

  payOrder = async (status, checksum, error, cartType) => {
    const cart_type = cartType
    const res = await this.api.post('/order/payment', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      data: {
        status: status,
        checksum: checksum,
        error: error,
        ...{ cart_type }
      },
      mock: this.api.getMock('payOrder')
    })
    return res
  }

  payOrderAuthorization = async (authorization, orderId, cartType) => {
    const res = await this.api.post('/order/payment/authorization', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      data: {
        authorization,
        orderId,
        ...{ cartType }
      },
      mock: this.api.getMock('payOrderAuthorization')
    })
    return res
  }

  getCheckoutData = async (opts = {}) => {
    const res = await this.api.get('/cart/checkout', {
      ...opts,
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      mock: this.api.getMock('getCheckoutData')
    })
    return res
  }

  setCheckoutData = async (data, cart) => {
    const cartType = cart
    const res = await this.api.post('/SetCheckoutData', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      data: {
        ...data,
        ...{ cartType }
      },
      mock: this.api.getMock('setCheckoutData')
    })
    return res
  }

  verifyPasswordForTobaccoOrder = async data => {
    const res = await this.api.post('/account/password/verification', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      data
    })
    return res
  }

  getRelatedProducts = async (opts = {}) => {
    const res = await this.api.get('/catalogue/products/related', {
      ...opts,
      headers: {
        ...cookie.authorizationTokenHeader(opts ? opts.req : undefined)
      },
      mock: this.api.getMock('relatedProducts')
    })
    return res
  }

  getUpgradeOfferProducts = async (offerid, opts = {}) => {
    const res = await this.api.get(
      '/catalogue/products/upgradeoffer/' + offerid,
      {
        ...opts,
        headers: {
          ...cookie.authorizationTokenHeader(opts ? opts.req : undefined)
        },
        mock: this.api.getMock('getUpgradeOfferProducts')
      }
    )
    return res
  }

  getSurveyLinks = async data => {
    const res = await this.api.post('/survey/buildsurveylinks', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      data,
      mock: this.api.getMock('getSurveyLinks')
    })
    return res
  }

  getPickupAreas = async (items, orderType) => {
    const res = await this.api.post('/order/pickup/areas', {
      headers: {
        'Content-type': 'application/json',
        ...cookie.authorizationTokenHeader()
      },
      data: {
        items: items,
        orderType: orderType
      },
      mock: this.api.getMock('getPickupAreas')
    })
    return res
  }

  getPickupStores = async data => {
    const res = await this.api.post('/order/pickup/stores', {
      headers: {
        'Content-type': 'application/json',
        ...cookie.authorizationTokenHeader()
      },
      data: {
        ...data
      },
      mock: this.api.getMock('getPickupStores')
    })
    return res
  }

  getDeliveryDatelist = async (items, orderType, postalCode) => {
    const res = await this.api.post('/order/delivery/list', {
      headers: {
        'Content-type': 'application/json',
        ...cookie.authorizationTokenHeader()
      },
      data: {
        items: items,
        orderType: orderType,
        zipCode: postalCode
      },
      mock: this.api.getMock('deliveryDateList')
    })
    return res
  }

  shortestDelivery = async items => {
    const res = await this.api.post('/order/delivery/shortest', {
      headers: {
        'Content-type': 'application/json',
        ...cookie.authorizationTokenHeader()
      },
      data: {
        orderType: 'EC',
        items
      },
      mock: this.api.getMock('shortestDelivery')
    })
    return res
  }

  externalCampaign = async (token, ecc) => {
    const res = await this.api.post('/cart/externalcampaign', {
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      data: {
        ecc
      }
    })
    return res
  }

  deleteCreditCard = async id => {
    const res = await this.api.delete('/payment/card/' + id, {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      mock: this.api.getMock('deleteCreditCard')
    })
    return res
  }

  editCreditCard = async (id, data) => {
    const res = await this.api.put('/payment/card/' + id, {
      data,
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      mock: this.api.getMock('editCreditCard')
    })
    return res
  }
}
